module.exports = __webpack_public_path__ + "static/img/shuiya.2512eb24.png";